// extracted by mini-css-extract-plugin
export default {"press":"press_press__hphQe","header":"press_header__yEGAA","desc":"press_desc__5uB25","wrap":"press_wrap__oSa4e"};